// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ResetPassword_componentWrapper__9J4DZ","form":"ResetPassword_form__LaUfO","actions":"ResetPassword_actions__HgejI"};